import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航">
      <ol className="flex flex-wrap items-center gap-2 text-sm text-foreground-500">
        <li>
          <Link to="/" className="hover:text-primary-700 transition-colors flex items-center gap-1">
            <i className="ri-home-4-line"></i>
            首页
          </Link>
        </li>
        {items.map((item) => (
          <li key={item.label} className="flex items-center gap-2">
            <i className="ri-arrow-right-s-line text-foreground-300"></i>
            {item.to ? (
              <Link to={item.to} className="hover:text-primary-700 transition-colors">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-900">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}